// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import Keycloak from 'keycloak-js'
import { CLIENTID_KEYCLOAK, REALM_KEYCLOAK, URL_KEYCLOAK } from "../Contantes/Constantes";
import SinapTheme from "../styles/SinapTheme";
import Error from "../Error/Error"
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Header from "../Header/Header";
import CircularIndeterminate from "../Componentes/CircularIndeterminate";
import { styled } from '@mui/material/styles';
import PaginaDeCargaGif from "../Componentes/PaginaDeCargaGif";
import SinapThemev2 from "../styles/SinapThemev2";

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    [theme.breakpoints.down('md')]: {
        left: '40%',
    },
    [theme.breakpoints.up('sm')]: {
        left: '50%',
    },
    [theme.breakpoints.up('md')]: {
        left: '50%',
    },
    [theme.breakpoints.up('lg')]: {
        left: '50%',
    },
}));

/**
 * El proposito de este modulo es instanciar keycloak y renderizar la aplicación una vez que keycloak pudo iniciar
 * Caso contrario, tira un error.
 * @private
 */


// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const _kc = new Keycloak({
    "realm": REALM_KEYCLOAK,
    "url": URL_KEYCLOAK,
    "clientId": CLIENTID_KEYCLOAK,
    "auth-server-url": URL_KEYCLOAK,
    "ssl-required": "external",
    "resource": "sinap",
    "public-client": true,
    "confidential-port": 0
})

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = async (onAuthenticatedCallback) => {
    ReactDOM.render(
        <>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={SinapThemev2}>
                    <CssBaseline />
                    <Header error={true} />
                    <Root>
                        <PaginaDeCargaGif />
                    </Root>

                </ThemeProvider>
            </StyledEngineProvider>
        </>,
        document.getElementById('root')
    )
    _kc.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    })
        .then((authenticated) => {
            onAuthenticatedCallback();
        })
        .catch(() => ReactDOM.render(
            <>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={SinapThemev2}>
                        <CssBaseline />
                        <Header error={true} />
                        <Root>
                            <PaginaDeCargaGif />
                        </Root>
                    </ThemeProvider>
                </StyledEngineProvider>
            </>
            ,
            document.getElementById('root')
        ));
};

const doLogin = _kc.login;

const doFirstLogin = async () => {
    await _kc.login()
}

const doLogout = async () => {
    await _kc.logout({ redirectUri: window.location.protocol + '//' + window.location.host });
}

const getToken = () => _kc.token;

function isLoggedIn() {
    try {
        return _kc.token !== undefined;
    } catch (e) {
        console.error(e)
    }
}

const updateToken = (successCallback) =>
    _kc.updateToken(5)
        .then(successCallback)
        .catch(doLogin);

const getUsername = () => _kc.tokenParsed?.preferred_username;

const getFiliacion = () => _kc.tokenParsed?.filiacion;

const getMail = () => _kc.tokenParsed?.email;

const getLegajo = () => _kc.tokenParsed?.legajoPersonaUTN;

const hasRole = (roles) => {
    return roles.every((role) => _kc.resourceAccess.sinap.roles.includes(role));
}

const masDeUnaFilicicion = () => {
    let filiaciones = getFiliacion();
    return filiaciones.length > 1;
}

const esFiliciaion = (tipo) => {
    const filiacion = getFiliacion();
    if (!filiacion) {
        console.error('Filiación es undefined o null');
        return false;
    }
    return filiacion.includes(tipo);
};

const KeyCloak = {
    _kc,
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    doFirstLogin,
    getToken,
    updateToken,
    getUsername,
    hasRole,
    getFiliacion,
    getMail,
    masDeUnaFilicicion,
    esFiliciaion,
    getLegajo
};






export default KeyCloak;